<script>
	import BoardBase from '../BoardBase.svelte';
	import Mission from '../Mission.svelte';
	import KhanTraits from './KhanTraits.svelte';

	export let board;
	export let p;
	export let isPreview = false;
	
</script>

<BoardBase {p} preview={isPreview} deck={board.deck} side="advanced" hideSideLabel>
	<svelte:fragment slot="missions">
		<Mission {p} preview={isPreview} mission={board.missions[0]} isAdvanced />
		<Mission {p} preview={isPreview} mission={board.missions[1]} isAdvanced />
		<Mission {p} preview={isPreview} mission={board.missions[2]} isAdvanced />
	</svelte:fragment>
	<svelte:fragment slot="tracks">
		<KhanTraits {p} preview={isPreview} />
	</svelte:fragment>
</BoardBase>
